<div [class.d--hidden]="isLoading">
  <ng-container>
    <header class="modal__header">
      <h2>
        {{ text?.title }}
      </h2>
      <button
        type="button"
        class="button modal__button--close"
        (click)="onCloseModal()"
        [attr.aria-label]="'general.label.close' | translate"
      >
        <i class="icon icon-ui-close--sm"></i>
      </button>
    </header>
    <div class="modal__content">
      <div class="modal__text" [internalInnerHtml]="text?.body" [userEventSource]="userEventSource"></div>
      <air-form
        #formComponent
        [controls]="form"
        [alternateReCaptchaActions]="alternateReCaptchaActions"
        [userEventSource]="userEventSource"
        (submitted)="submitValues($event)"
      >
      </air-form>
    </div>
    <div class="modal__footer--full-width-ends">
      @if (selectedViewState === 'emailResetCode') {
        <button
          type="button"
          class="button button--secondary"
          [class.button--disabled]="isResendDisabled"
          [airButtonLoading]="isResendLoading"
          [disabled]="isResendDisabled"
          (click)="resendCode($event)"
        >
          <span>{{ 'account.label.resend_verification_code' | translate }}</span>
        </button>
      }

      <button
        type="submit"
        class="button form__button button--cta"
        [airButtonLoading]="isSubmitting"
        (click)="enableAlternateReCaptcha ? submitAlternateReCaptcha() : submit($event)"
      >
        <span>{{
          (selectedViewState === 'phoneNumber' ? 'account.label.send_verification_code' : 'general.label.confirm') | translate
        }}</span>
      </button>
    </div>
  </ng-container>
</div>
